import { render, staticRenderFns } from "./MoveToFixedDetailsPopup.vue?vue&type=template&id=8b91ba1e&scoped=true"
import script from "./MoveToFixedDetailsPopup.vue?vue&type=script&lang=js"
export * from "./MoveToFixedDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedDetailsPopup.vue?vue&type=style&index=0&id=8b91ba1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b91ba1e",
  null
  
)

export default component.exports